<template>
    <div class="schools-state">
        <staticWelcomeSearch :imageUrl="schoolSrc" :title="schoolTitle" :searchType="'Schools'"/>
        <mvtPageMenu :menuType="'Schools'"/>
        <schoolsBreadcrumb :breadCrumb="getBreadCrumbData"/>
        <section v-if="data.dataList && data.dataList.length" v-for="(list, index) in data.dataList">
          <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
            <mvtCollapsibleLinks
                :title="list.title"
                titleClass="f3 text-capitalize text-bold p-y-2"
                :links='formatDataList(list.data)'
                :key="index"
                :initialExpandedState="true"
            />
          </div>
        </section>
        <section>
          <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
                <hr/>
                <a class="link" :href="glb.appUrl+data.stateInfo.nameForUrl+'/school-district/'">Browse By School District in {{data.stateName}}</a>
                <a class="link" :href="glb.appUrl+'schools/'">All States</a>
          </div>
        </section>
    </div>
</template>

<script src="./schools-state.js"></script>

<style lang="scss">
@use './schools-state.scss' as *;
</style>
